import { render, staticRenderFns } from "./OperationList_new.vue?vue&type=template&id=ba95cc66&"
import script from "./OperationList_new.vue?vue&type=script&lang=js&"
export * from "./OperationList_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports